import { Box, CircularProgress } from "@mui/material";
import { useEntityContact } from "../../../hooks/Entity";
import EntityContacts from "../../Entities/Contacts/EntityContacts";

interface ContactsTabProps {
  entityId?: string;
  entityName?: string;
  handleError?: (err: any) => void;
}

const ContactsTab: React.FC<ContactsTabProps> = ({ entityId, entityName, handleError }) => {
  const { contactsData, isPending, createContact, updateContact, deleteContact, setPrimaryContact } = useEntityContact(entityId);

  if (isPending && contactsData.length === 0)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );

  return (
    <EntityContacts
      entityId={Number(entityId)}
      entityName={entityName ?? ""}
      contactsData={contactsData}
      onCreate={async (values) => {
        await createContact(values).catch(handleError)
      }}
      onUpdate={async (id, values) => {
        await updateContact({ ContactId: id, values }).catch(handleError)
      }}
      onDelete={async (id) => {
        await deleteContact(id).catch(handleError)
      }}
      onSetPrimary={async (id) => {
        await setPrimaryContact(id).catch(handleError)
      }}
    />
  );
};

export default ContactsTab;